import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEdit, FaTrash, FaList, FaArrowLeft } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import Search from "../../../../common/Search";
import {
  SolutionList,
  DeleteSolution,
  SolutionChangeStatus,
} from "../../../../redux/services/ContentService/content.Services";
import Pagination from "../../../../common/Pagination";
import { successToast, errorToast } from "../../../../Utils/toast";

function Solutionlist() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedModule, setSelectedModule] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("selectedModule");
    if (stored) setSelectedModule(JSON.parse(stored));
  }, []);

  const moduleId = selectedModule?.id;

  const [totalRecords, setTotalRecords] = useState(0);
  const [solutionlist, setSolutionList] = useState([]);
  const [limit, setLimit] = useState(100);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const refreshData = useSelector((state) => state.productModal.refreshData);

  const fetchSolution = async () => {
    if (!moduleId) return;
    try {
      setLoading(true);
      const payload = { page, search, limit, status, module_id: moduleId };
      const res = await SolutionList(payload);
      setSolutionList(res?.data || []);
      setLastPage(res?.last_page || 1);
      setTotalRecords(res?.total || 0);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSolution();
    // eslint-disable-next-line
  }, [page, search, status, refreshData, moduleId]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= lastPage) setPage(newPage);
  };

  const handleViewSections = (solution) => {
    localStorage.setItem("selectedSolution", JSON.stringify(solution));
    navigate("/sections-list");
  };

  const handleAddSolution = () => {
    navigate("/add-solution");
  };

  const handleViewSolution = (item) => {
    localStorage.setItem("viewSolution", JSON.stringify(item));
    navigate("/view-solution");
  };

  const handleEditSolution = (item) => {
    localStorage.setItem("editSolution", JSON.stringify(item));
    navigate("/edit-solution");
  };

  const handleDeleteSolution = async (item) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete "${item.name}"?`
    );
    if (!confirmDelete) return;

    try {
      const res = await DeleteSolution({ id: item.id });

      if (res?.success) {
        successToast(res?.message || "Solution deleted successfully!");
        fetchSolution();
      } else {
        errorToast(res?.message || "Failed to delete solution");
      }
    } catch (err) {
      console.log(err);
      errorToast(
        err?.response?.data?.message || "Something went wrong"
      );
    }
  };

  const handleToggleStatus = async (item) => {
    const confirmToggle = window.confirm(`Change status of "${item.name}"?`);
    if (!confirmToggle) return;

    try {
      const newStatus = item.status == 1 ? 0 : 1;
      const res = await SolutionChangeStatus({
        id: item.id,
        status: newStatus,
      });

      if (res?.success) {
        successToast(res?.message || "Status changed successfully!");
        fetchSolution();
      } else {
        errorToast(res?.message || "Failed to change status");
      }
    } catch (err) {
      console.log(err);
      errorToast(
        err?.response?.data?.message || "Something went wrong"
      );
    }
  };

  return (
    <div>
      <div className="d-md-flex d-block align-items-center justify-content-between mt-1 page-header-breadcrumb">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="page-header">
            <div>
              <h3 className="page-title mb-0">
                Solution List
                {selectedModule && (
                  <span className="text-muted ms-2">
                    — {selectedModule.name}
                  </span>
                )}
              </h3>
              <nav className="page-breadcrumb">
                <Link to="/">Home</Link>
                <span className="mx-2">/</span>
                <Link to="/module-list">Modules</Link>
                <span className="mx-2">/</span>
                {selectedModule && (
                  <>
                    <span>{selectedModule.name}</span>
                    <span className="mx-2">/</span>
                  </>
                )}
                <span>Solutions</span>
              </nav>
            </div>
          </div>

          <div className="d-flex align-items-center gap-2">
            <button className="add-btn" onClick={handleAddSolution}>
              + Add Solution
            </button>

            <Link
              to="/module-list"
              className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
              style={{ width: "40px", height: "40px", borderRadius: "8px" }}
            >
              <FaArrowLeft />
            </Link>
          </div>
        </div>
      </div>

      <div className="main_page">
        {!moduleId && (
          <div className="alert alert-warning mx-2">
            ⚠️ No module selected. Please go back and select a module.
          </div>
        )}

        {(totalRecords > 0 || search) && (
          <div className="d-flex justify-content-end align-items-center mx-2 mb-2">
            <Search
              search={search}
              placeholder="Search Solution..."
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
            />
          </div>
        )}

        <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                <tr>
                  <th>Sr</th>
                  <th>Module</th>
                  <th>Name</th>
                  {/* <th>Slug</th> */}
                  <th>Change Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {solutionlist.length > 0 ? (
                  solutionlist.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1 + (page - 1) * limit}</td>
                      <td>{item.module?.name || "-"}</td>
                      <td>{item.name}</td>
                      {/* <td>
                        <span className="badge bg-secondary">{item.slug}</span>
                      </td> */}
                      <td>
                        <div className="city-status-switch">
                          <input
                            type="checkbox"
                            id={`status-${item.id}`}
                            className="city-status-input"
                            checked={item.status == 1}
                            onChange={() => handleToggleStatus(item)}
                          />
                          <label
                            htmlFor={`status-${item.id}`}
                            className="city-status-label"
                          >
                            <span className="city-status-ball"></span>
                            <span className="city-status-text">
                              {item.status == 1 ? "Active" : "Inactive"}
                            </span>
                          </label>
                        </div>
                      </td>
                      <td className="text-center">
                        <div className="d-flex align-items-center justify-content-center gap-1">
                          <button
                            className="st-action-btn st-view-btn"
                            title="View Sections"
                            onClick={() => handleViewSections(item)}
                           
                          >
                            <FaList />
                          </button>

                          <button
                            className="st-action-btn st-view-btn"
                            onClick={() => handleViewSolution(item)}
                          >
                            <FaEye />
                          </button>

                          <button
                            className="st-action-btn st-edit-btn"
                            onClick={() => handleEditSolution(item)}
                          >
                            <FaEdit />
                          </button>

                          <button
                            className="st-action-btn st-delete-btn"
                            onClick={() => handleDeleteSolution(item)}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-5">
                      <h5 className="mb-0">
                        {!moduleId ? "No module selected" : "No Data Found"}
                      </h5>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {lastPage > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={lastPage}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Solutionlist;